export default "__VITE_ASSET__Bbh4XQy8__"